/**
 * @fileoverview Data model to hold a related set of tasks, analogous to a section in the UX flow.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

export class TaskGroup {
  /**
   * @param {{
   *   id: string,
   *   name: string,
   *   tasks: !Array<?>,
   * }} params
   */
  constructor(params) {
    /** @type {string} */
    this.id = params.id;
    /** @type {string} */
    this.name = params.name;
    /** @type {!Array<?>} */
    this.tasks = params.tasks;
  }
}
